<template>
  <div class="currency-selector">
    <el-select
      v-model="selectedCurrency"
      @change="handleCurrencyChange"
      class="currency-select"
    >
      <template #prefix>
        <img
          v-if="selectedCurrencyData"
          :src="selectedCurrencyData.flag"
          :alt="selectedCurrencyData.code"
          class="currency-flag"
        />
      </template>
      <el-option
        v-for="currency in currencies"
        :key="currency.code"
        :value="currency.code"
        :label="`${currency.code.toUpperCase()} - ${currency.name}`"
      >
        <span class="currency-option">
          <img :src="currency.flag" :alt="currency.code" class="currency-flag" />
          {{ currency.code.toUpperCase() }} - {{ currency.name }}
        </span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'CurrencySelector',
  props: {
    currency: {
      type: String,
      default: 'usd'
    }
  },
  data() {
    return {
      selectedCurrency: this.currency?.toLowerCase() || 'usd',
      currencies: [
        { code: 'usd', name: 'US Dollar', flag: 'https://flagcdn.com/w20/us.png' },
        { code: 'cop', name: 'Colombian Peso', flag: 'https://flagcdn.com/w20/co.png' },
        { code: 'eur', name: 'Euro', flag: 'https://flagcdn.com/w20/eu.png' },
        { code: 'brl', name: 'Brazilian Real', flag: 'https://flagcdn.com/w20/br.png' }
      ]
    }
  },
  computed: {
    selectedCurrencyData() {
      return this.currencies.find(c => c.code === this.selectedCurrency.toLowerCase())
    }
  },
  methods: {
    handleCurrencyChange() {
      this.$emit('onSelect', this.selectedCurrency.toUpperCase())
    }
  }
}
</script>

<style scoped>
.currency-selector {
  margin: 0;
}

.currency-select {
  width: 220px;
  @media screen and (max-width: 968px) {
    width: 100%;
  }
}

.currency-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.currency-flag {
  width: 20px;
  height: auto;
  vertical-align: middle;
}
</style>